import {
  SavedSearchesQueryQuery,
  SavedSearchesQueryQueryVariables,
} from "@outschool/gql-frontend-generated";
import { useQueryWithPreviousData } from "@outschool/ui-apollo";
import { useSession } from "@outschool/ui-auth";
import React from "react";

import { SavedSearchesQuery } from "./graphql";

export type SavedSearch = NonNullable<
  SavedSearchesQueryQuery["currentUser"]
>["savedSearches"][number];

export function useSavedSearches() {
  const { isLoggedIn } = useSession();
  const { loading, error, data, refetch } = useQueryWithPreviousData<
    SavedSearchesQueryQuery,
    SavedSearchesQueryQueryVariables
  >(SavedSearchesQuery, {
    skip: !isLoggedIn,
  });

  const savedSearches = React.useMemo(() => {
    return data?.currentUser?.savedSearches || [];
  }, [data?.currentUser?.savedSearches]);

  return {
    loading,
    error,
    savedSearches,
    refetch,
  };
}
